import React, { memo, Fragment, useState } from 'react'
import { string, object, array, func, bool } from 'prop-types'
import { NAME, EMAIL, BRANCH, EMPTY_ARRAY, EMPTY_OBJECT, PHONE, COMPANY_WEBSITE } from '../../../helpers/constants'
import ButtonGroup from '../buttons/button-group'
import UserInfoSummary from './user-info-summary'
import LocationFields from './location-fields'
import Input from './input'

const UserInfo = memo(({
  name = '',
  email = '',
  branch = '',
  phone = '',
  countryOptions = EMPTY_ARRAY,
  locationOptions = EMPTY_ARRAY,
  country = EMPTY_OBJECT,
  location = EMPTY_OBJECT,
  errors = EMPTY_OBJECT,
  onFieldChangeHandler,
  includeBranch,
  includePhone,
  includeCompanyWebsite,
  companyWebsite = ''
}) => {
  const [editableUserInfo, setEditableUserInfo] = useState(!name.length || !email.length)
  const [editableLocation, setEditableLocation] = useState(!country.value || !location.value)
  const [editableBranch, setEditableBranch] = useState(!branch)
  const [editableCompanyWebsite, setEditableCompanyWebsite] = useState(!companyWebsite?.length)
  const enableEditMode = () => {
    setEditableUserInfo(true)
    setEditableLocation(true)
    setEditableBranch(true)
  }

  if (!editableUserInfo && !editableLocation && (!includeBranch || !editableBranch) && !editableCompanyWebsite) {
    return (<UserInfoSummary
      userName={name}
      email={email}
      branch={includeBranch && branch}
      country={country.label}
      phone={includePhone && phone}
      location={location.label}
      companyWebsite={companyWebsite}
      onEditHandler={enableEditMode} />)
  } else {
    return (<Fragment>
      { includeBranch &&
        <ButtonGroup
          label={window.NFT.I18n.single_info_request.branch}
          options={window.NFT.I18n.single_info_request.branch_options}
          value={branch}
          fieldName={BRANCH}
          errorMessage={errors[BRANCH]}
          onValueChange={value => onFieldChangeHandler(BRANCH, value)} />
      }
      <Input label={window.NFT.I18n.single_info_request.name} type='text' value={name}
        fieldName={NAME} errorMessage={errors[NAME]}
        onValueChange={value => onFieldChangeHandler(NAME, value)} />
      <Input label={window.NFT.I18n.single_info_request.work_email} type='email' value={email}
        fieldName={EMAIL} errorMessage={errors[EMAIL]}
        onValueChange={value => onFieldChangeHandler(EMAIL, value)} />
      {includeCompanyWebsite && <Input label={window.NFT.I18n.single_info_request.company_website} type='text' defaultValue={companyWebsite} /* Company website type validation happens in validator.js */
        fieldName={COMPANY_WEBSITE} errorMessage={errors[COMPANY_WEBSITE]}
        onValueChange={value => onFieldChangeHandler(COMPANY_WEBSITE, value)} />}
      <LocationFields
        countryOptions={countryOptions}
        locationOptions={locationOptions}
        country={country}
        location={location}
        onChange={onFieldChangeHandler}
        errors={errors}
        forceEditableState={editableLocation} />
      { includePhone &&
        <Input label={window.NFT.I18n.single_info_request.phone} type='tel' value={phone}
          fieldName={PHONE} errorMessage={errors[PHONE]}
          onValueChange={value => onFieldChangeHandler(PHONE, value)} />
      }
    </Fragment>)
  }
});

UserInfo.propTypes = {
  name: string,
  email: string,
  branch: string,
  phone: string,
  countryOptions: array,
  locationOptions: array,
  country: object,
  location: object,
  errors: object,
  onFieldChangeHandler: func,
  includeBranch: bool,
  includePhone: bool
}

UserInfo.displayName = 'UserInfo';

export default UserInfo